import { z } from "zod";
// ---------------------------------------------------------------------------
// Piste Jeux (G2 prépare, G1 utilise GAME_*) — barème de points et niveaux.
// Constantes partagées client/serveur : le client affiche, le serveur crédite.
// Source de vérité du solde : le ledger PointEvent (idempotent par
// userId+type+refId) ; User.pointsBalance n'est qu'un cache.
// ---------------------------------------------------------------------------
export const PointEventTypeSchema = z.enum([
    "MESSAGE_SENT",
    "CONTACT_ACCEPTED",
    "BOOKING_CREATED",
    "ORDER_PAID",
    "REFERRAL_SIGNUP",
    "GAME_PLAYED",
    "GAME_WIN",
]);
export const POINT_VALUES = {
    MESSAGE_SENT: 2,
    CONTACT_ACCEPTED: 25,
    BOOKING_CREATED: 30,
    ORDER_PAID: 50,
    REFERRAL_SIGNUP: 100,
    GAME_PLAYED: 5,
    GAME_WIN: 20,
};
/** Plafonds anti-farming : points max crédités par type et par jour (UTC). */
export const DAILY_CAPS = {
    MESSAGE_SENT: 40,
    GAME_PLAYED: 50,
    GAME_WIN: 100,
};
/** Seuils de niveaux — ordre croissant strict sur `min`. */
export const LEVELS = [
    { min: 0, name: "Novice" },
    { min: 100, name: "Apprenti" },
    { min: 300, name: "Bavard" },
    { min: 800, name: "Éloquent" },
    { min: 2000, name: "Orateur" },
    { min: 5000, name: "Virtuose" },
    { min: 12000, name: "Légende" },
];
export function levelForPoints(points) {
    const safe = Math.max(0, points);
    let idx = 0;
    for (let i = LEVELS.length - 1; i >= 0; i--) {
        if (safe >= LEVELS[i].min) {
            idx = i;
            break;
        }
    }
    const current = LEVELS[idx];
    const next = idx + 1 < LEVELS.length ? LEVELS[idx + 1] : null;
    const progress = next
        ? (safe - current.min) / (next.min - current.min)
        : 1;
    return {
        level: idx,
        name: current.name,
        min: current.min,
        nextMin: next ? next.min : null,
        progress: Math.min(1, Math.max(0, progress)),
    };
}
// ---------------------------------------------------------------------------
// REST DTOs
// ---------------------------------------------------------------------------
/** WS temps réel — poussé à l'utilisateur quand des points sont crédités
 *  (jamais pour MESSAGE_SENT : un toast par message serait envahissant). */
export const PointsAwardedEventSchema = z.object({
    type: z.literal("points_awarded"),
    pointType: PointEventTypeSchema,
    points: z.number().int(),
    balance: z.number().int(),
});
export const PointEventDTOSchema = z.object({
    type: PointEventTypeSchema,
    points: z.number().int(),
    createdAt: z.string(),
});
export const MePointsDTOSchema = z.object({
    balance: z.number().int(),
    level: z.number().int(),
    levelName: z.string(),
    nextLevelMin: z.number().int().nullable(),
    progress: z.number(),
    recentEvents: z.array(PointEventDTOSchema),
});
/** Classement entre contacts (G2) — moi inclus, trié par points décroissants. */
export const LeaderboardEntryDTOSchema = z.object({
    rank: z.number().int(),
    userId: z.string(),
    displayName: z.string(),
    points: z.number().int(),
    levelName: z.string(),
    isMe: z.boolean(),
});
//# sourceMappingURL=points.js.map